import { render, staticRenderFns } from "./create-credentials.vue?vue&type=template&id=471ac5ee&"
import script from "./create-credentials.vue?vue&type=script&lang=js&"
export * from "./create-credentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports